import { render, staticRenderFns } from "./ModificaAlertPaziente.vue?vue&type=template&id=6c47a376&"
import script from "./ModificaAlertPaziente.vue?vue&type=script&lang=js&"
export * from "./ModificaAlertPaziente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports